import { atom } from "recoil";

import {
  BookingDto,
  IPassengerDto,
  IProduceJoinPassengerPreviewDto,
  ReasonDtoDropdownItem,
} from "../../dto";
import {
  AssignDocksDuringProductionEnum,
  BookingCalendarViewMode,
  BulkCreateBookingState,
  BulkProduceTypeEnum,
  DirectionEnum,
  DirectionsServiceEnum,
  ProductionTypeEnum,
} from "../../enums";
import {
  BookingCellId,
  IApprovalBookingConflict,
  IProductionSummaryItem,
  ITypeormWhereCriteria,
  TBookingBulkToken,
} from "../../models";

/*
 * Critical for performance be careful to make selectors from this atom
 * any changes to this atom(add or remove selected cells)
 * will trigger re-calculation and re-caching all dependencies(selectors) */
export const selectedCellsBookingCalendarAtom = atom<Set<BookingCellId>>({
  key: "selectedCellsBookingCalendarAtom",
  default: new Set(),
});

export const passengersListBookingAtom = atom<IPassengerDto[]>({
  key: "passengersListBookingAtom",
  default: [],
});

export const bookingCalendarViewModeAtom = atom<BookingCalendarViewMode>({
  key: "bookingCalendarViewModeAtom",
  default: BookingCalendarViewMode.AllPassengers,
});

export const currentBulkSetBookingsTokenAtom = atom<TBookingBulkToken | null>({
  key: "currentBulkSetBookingsTokenAtom",
  default: null,
});

export const bulkApprovalBookingConflictsAtom = atom<
  Map<BookingCellId, IApprovalBookingConflict[]>
>({
  key: "bulkApprovalBookingConflictAtom",
  default: new Map(),
});

export const bulkApprovalBookingConflictsUpdatedAtom = atom<
  Map<BookingCellId, IApprovalBookingConflict[]>
>({
  key: "bulkApprovalBookingConflictsUpdatedAtom",
  default: new Map(),
});

export const bulkCreateBookingStateAtom = atom<BulkCreateBookingState>({
  key: "bulkCreateBookingStateAtom",
  default: BulkCreateBookingState.IsForm,
});

export const bulkApprovalBookingConflictsReasonDropdownItemsAtom = atom<
  ReasonDtoDropdownItem[]
>({
  key: "bulkApprovalBookingConflictsReasonDropdownItemsAtom",
  default: [],
});

export const bookingsProductionDrawerConfigurationAtom = atom<null | {
  action: BulkProduceTypeEnum;
  productionType?: ProductionTypeEnum[];
  criteria: ITypeormWhereCriteria<BookingDto> & IProduceJoinPassengerPreviewDto;
  summaryItems: IProductionSummaryItem[];
  rideTypeId?: number;
  assignDocksDuringProduction?: AssignDocksDuringProductionEnum;
  useCustomDirectionsService?: boolean;
  directionsService?: DirectionsServiceEnum;
}>({
  key: "bookingsProductionDrawerConfigurationAtom",
  default: null,
});

export const lastChosenBulkCreateBookingDirectionAtom =
  atom<DirectionEnum | null>({
    key: "lastChosenBulkCreateBookingDirectionAtom",
    default: null,
  });
